import { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useRawTable } from "../../hooks";
import {
  option_chronic_disease,
  option_chronic_disease_obj,
} from "../../../service/option/common";
import { decimalAddZero } from "../../../service/common";
import moment from "moment";

export default function Module_ElderlyHealth_ChronicDiseaseCountStatistic({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
}) {
  const redux_diagram = useSelector((state) => state.diagram);
  const [diseaseType, setDiseaseType] = useState([]);
  const moduleDataTemp = useMemo(
    () => ({
      ...moduleData,
      columns: [
        {
          key: "type",
          field: "type",
          header: "罹患慢性病數量",
        },
        ...(diseaseType || []).map((item) => ({
          key: item,
          field: item,
          header: `${item}種`,
        })),
        {
          key: "total",
          field: "total",
          header: "小計",
        },
      ],
    }),
    [moduleData, diseaseType]
  );
  const { setTbData, renderTable } = useRawTable({
    setting: moduleDataTemp,
    nullTransfer: "-",
    subTitleBgColor: "elderlytitle1",
  });
  const filterYear =
    redux_diagram.filterSetting?.ChronicDiseaseCountStatistic?.noback_year
      ?.value ?? Number(moment().format("YYYY"));

  useEffect(() => {
    if (!apiData) return;

    let formatData = apiData
      .filter((item) =>
        [filterYear, filterYear - 1911].includes(Number(item["篩檢年份"]))
      )
      .reduce((pre, cur) => ({ ...pre, [cur["個案ID"]]: cur }), {});
    formatData = Object.values(formatData);
    let data = { count: { total: 0 }, percent: {} };
    formatData.forEach((item) => {
      // 主要病徵
      let statistic = item["慢性疾病統計"]?.split("#") ?? [];
      if (statistic.includes(option_chronic_disease[0].label)) statistic = 0;
      else if (statistic.includes(option_chronic_disease[12].label))
        statistic = statistic.length - 1;
      else statistic = statistic.length;

      // 其他病徵
      let otherType = [
        ...(item["慢性疾病統計其他"] ? [item["慢性疾病統計其他"]] : []),
        ...(item["慢性疾病統計癌症"] ? [item["慢性疾病統計癌症"]] : []),
        // ...(item["慢性疾病統計其他"]
        //   ? item["慢性疾病統計其他"].indexOf("、") !== -1
        //     ? item["慢性疾病統計其他"].split("、")
        //     : item["慢性疾病統計其他"].split("、") // " "
        //   : []),
        // ...(item["慢性疾病統計癌症"]
        //   ? item["慢性疾病統計癌症"].indexOf("、") !== -1
        //     ? item["慢性疾病統計癌症"].split("、")
        //     : item["慢性疾病統計癌症"].split("、") // " "
        //   : []),
      ];
      statistic += otherType.length;

      if (!data.count[statistic]) data.count[statistic] = 0;
      data.count[statistic]++;
      data.count.total++;
    });

    let type = Object.keys(data.count)
      .filter((item) => item !== "total")
      .sort(function (pre, next) {
        return pre - next;
      });
    setDiseaseType(type);

    data.percent = {
      ...Object.entries(data.count).reduce(
        (pre, [curKey, curVal]) => ({
          ...pre,
          [curKey]: `${Math.round((curVal / data.count.total) * 1000) / 10}%`,
        }),
        {}
      ),
      type: "占比(%)",
    };

    setTbData({
      raw: [
        {
          ...Object.entries(data.count).reduce(
            (pre, [curKey, curVal]) => ({
              ...pre,
              [curKey]:
                typeof curVal === "number"
                  ? decimalAddZero({
                      rawVal: curVal ?? 0,
                      decimalShowRaw: true,
                    })
                  : curVal,
            }),
            {}
          ),
          type: "人數",
        },
        data.percent,
      ],
      format: null,
      export: null,
    });
  }, [apiData]);

  return (
    <>
      {renderTable({
        moduleTitle: `${moduleData.label}(${filterYear})`,
      })}
    </>
  );
}
